const rules = [
  {
    number: '01',
    title: 'Regula 1% / 2%',
    desc: 'Nu risca niciodată mai mult de 1-2% din capitalul total pe o singură tranzacție. Dacă ai 1.000$, risca maxim 10-20$ per tranzacție.',
    icon: 'ri-percent-line',
  },
  {
    number: '02',
    title: 'Stop-Loss Obligatoriu',
    desc: 'Setează întotdeauna un stop-loss înainte de a deschide o tranzacție. Acesta limitează pierderea maximă posibilă indiferent ce se întâmplă.',
    icon: 'ri-shield-line',
  },
  {
    number: '03',
    title: 'Risk/Reward Ratio',
    desc: 'Caută tranzacții cu un raport risc/câștig de cel puțin 1:2. Dacă riști 50 pip, țintește un profit de minim 100 pip.',
    icon: 'ri-scales-3-line',
  },
  {
    number: '04',
    title: 'Diversificare',
    desc: 'Nu tranzacționa toate perechile în același timp. Concentrează-te pe 2-3 perechi pe care le cunoști bine și le urmărești regulat.',
    icon: 'ri-pie-chart-line',
  },
];

export default function GestionareaRiscului() {
  return (
    <section id="risc" style={{ background: '#f5f1e8' }} className="py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span
            className="inline-block text-sm font-semibold uppercase tracking-widest mb-4 px-4 py-1 rounded-full"
            style={{ background: 'rgba(78,205,196,0.12)', color: '#4ecdc4' }}
          >
            05 — Gestionarea Riscului
          </span>
          <h2
            className="text-4xl md:text-5xl font-bold leading-tight mb-4"
            style={{ fontFamily: 'Playfair Display, serif', color: '#0f1419' }}
          >
            Protejează-ți
            <br />
            <span style={{ color: '#4ecdc4' }}>Capitalul</span> în Forex
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto">
            Managementul riscului este diferența dintre un trader de succes și unul care pierde tot
          </p>
        </div>

        {/* Quote card */}
        <div
          className="rounded-3xl overflow-hidden grid grid-cols-1 lg:grid-cols-3 mb-16"
          style={{ background: '#0f1419' }}
        >
          {/* Image */}
          <div className="relative h-64 lg:h-auto">
            <img
              src="https://public.readdy.ai/ai/img_res/f6cf8dae3e9b9128c25e18c08817829a.jpg"
              alt="Risk Management"
              className="w-full h-full object-cover object-top"
            />
          </div>

          {/* Quote content */}
          <div className="lg:col-span-2 p-10 md:p-16 flex flex-col justify-center">
            <div className="text-7xl leading-none mb-4" style={{ color: 'rgba(78,205,196,0.3)', fontFamily: 'Georgia, serif' }}>
              "
            </div>
            <p className="text-white text-xl md:text-2xl leading-relaxed mb-8" style={{ fontFamily: 'Playfair Display, serif' }}>
              Managementul riscului este diferența dintre un trader de succes și unul care pierde tot.
              Învață să îți protejezi capitalul și să tranzacționezi responsabil.
            </p>
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-full flex-shrink-0" style={{ background: '#4ecdc4' }}>
                <i className="ri-user-line text-white text-lg"></i>
              </div>
              <div>
                <p className="text-white font-bold">Expert Forex Trader</p>
                <p className="text-gray-400 text-sm">10+ ani experiență în piețe</p>
              </div>
            </div>
          </div>
        </div>

        {/* Rules grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {rules.map((r, i) => (
            <div
              key={i}
              className="p-6 rounded-2xl bg-white border border-gray-100 transition-all duration-300 hover:-translate-y-1 cursor-default group"
            >
              <div className="flex items-start justify-between mb-5">
                <div
                  className="w-12 h-12 flex items-center justify-center rounded-xl"
                  style={{ background: 'rgba(78,205,196,0.12)' }}
                >
                  <i className={`${r.icon} text-xl`} style={{ color: '#4ecdc4' }}></i>
                </div>
                <span className="text-3xl font-bold" style={{ color: 'rgba(78,205,196,0.2)', fontFamily: 'Playfair Display, serif' }}>
                  {r.number}
                </span>
              </div>
              <h3 className="font-bold text-base mb-2" style={{ color: '#0f1419' }}>{r.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>

        {/* Warning banner */}
        <div
          className="rounded-2xl p-6 flex flex-col sm:flex-row items-center gap-5"
          style={{ background: 'rgba(255,181,167,0.15)', border: '1px solid rgba(255,181,167,0.4)' }}
        >
          <div className="w-12 h-12 flex items-center justify-center rounded-full flex-shrink-0" style={{ background: '#ffb5a7' }}>
            <i className="ri-alert-line text-white text-xl"></i>
          </div>
          <div>
            <p className="font-bold text-gray-800 mb-1">Avertisment Important</p>
            <p className="text-sm text-gray-600 leading-relaxed">
              Tranzacționarea Forex implică risc semnificativ de pierdere a capitalului. Între 74-89% dintre conturile retail CFD pierd bani.
              Asigură-te că înțelegi riscurile și că nu investești bani pe care nu ți-i permiți să-i pierzi.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
